import React, { createContext, ReactNode, useContext, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { en } from '../data/i18n/en';
import { ru } from '../data/i18n/ru';
import { et } from '../data/i18n/et';
import { stable } from '../data/stable';
import { Lang, Localized } from '../types/content';
import { Dictionary } from '../types/i18n';
interface LanguageValue {
  lang: Lang;
  setLang: (lang: Lang) => void;
  t: Dictionary;
  l: (value: Localized) => string;
}
export const languages: Lang[] = ['et', 'ru', 'en'];
export function isLang(value: string | undefined): value is Lang {
  return languages.includes(value as Lang);
}
const dictionaries: Record<Lang, Dictionary> = {
  en,
  ru,
  et
};
const LanguageContext = createContext<LanguageValue | null>(null);
interface LanguageProviderProps {
  lang: Lang;
  children: ReactNode;
}
export function LanguageProvider({
  lang,
  children
}: LanguageProviderProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const t = dictionaries[lang];
  useEffect(() => {
    document.documentElement.lang = lang;
    document.title = `${stable.name} — ${t.hero.title}`;
  }, [lang, t]);
  const value: LanguageValue = {
    lang,
    setLang: next => navigate(`/${next}${location.hash}`),
    t,
    l: v => v[lang]
  };
  return <LanguageContext.Provider value={value} data-id="element-275" data-mp="32z1pi3tb3jqa">{children}</LanguageContext.Provider>;
}
export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used inside LanguageProvider');
  return ctx;
}